import { useEffect } from 'react'

import { getIdwellToIdwellFilesAccess } from '../../IdwellToIdwell.api'

export function useIdwellToIdwellGetFilesAccess(outboundCompanyUuid) {
  useEffect(() => {
    if (outboundCompanyUuid) {
      getIdwellToIdwellFilesAccess(outboundCompanyUuid).catch(console.error)
    }
  }, [outboundCompanyUuid])
}
